require("core-js/modules/es6.object.assign");

module.exports = Object.assign;